import gsap from 'gsap';
import { stations, useTourStore } from '@/state/tour';

export function goToStation(index: number) {
  const i = Math.max(0, Math.min(stations.length - 1, index));
  const at = stations[i]!.waypoints[0]!.at;
  const max = document.documentElement.scrollHeight - window.innerHeight;
  const reduced = useTourStore.getState().reducedMotion;
  const target = at * max;
  if (reduced) {
    window.scrollTo({ top: target });
    return;
  }
  const proxy = { y: window.scrollY };
  gsap.to(proxy, {
    y: target,
    duration: 1.1,
    ease: 'power2.inOut',
    overwrite: true,
    onUpdate: () => window.scrollTo({ top: proxy.y }),
  });
}
